import React from "react";

export default function StepDescription({ datajoptiktok, lang }) {
    if (!datajoptiktok) return null;
    const currentLang = lang || "vi";

    // ====== 1️⃣ WEB SEARCH ======
    if (datajoptiktok.category.includes("web_search")) {
        return {
            1: (
                <>
                    <div className="mt-3 p-1 bg-gradient-to-r from-pink-200 to-purple-200 rounded-md shadow-md">
                        <form>
                            <div className="text-base text-blue-500 font-bold mb-2">
                                Mở điện thoại bắt đầu quay màn hình:
                            </div>
                        </form>
                    </div>
                    <div className="bg-gray-100">
                        {datajoptiktok.length !== 0 && (
                            <div className="max-w-xl w-full p-2 space-y-2 bg-white rounded-md shadow-md text-center">
                                <div className="text-black text-base">
                                    Sao chép từ khóa{" "}
                                    <span className="text-xl font-bold text-blue-500 cursor-pointer">
                                        {datajoptiktok.magiaodich}
                                    </span>{" "}
                                    dán lên{" "}
                                    <span className="text-xl font-bold text-blue-500 cursor-pointer">
                                        Google.com
                                    </span>{" "}
                                    để tìm kiếm trang web
                                </div>
                            </div>
                        )}
                    </div>
                </>
            ),
            2: (
                <div>
                    {datajoptiktok.length !== 0 && (
                        <>
                            Bấm vào website giống ảnh bên dưới{" "}
                            <div className="items-center justify-center bg-gray-100">
                                <div className="max-w-xl w-full p-6 space-y-6 bg-white rounded-md shadow-md">
                                    <div className="flex items-center space-x-4">
                                        <img
                                            className="h-10"
                                            src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png"
                                            alt="Google Logo"
                                        />
                                        <div className="flex-grow px-4 py-2 border text-black border-gray-300 rounded-md">
                                            {datajoptiktok.magiaodich}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="text-lg text-black font-bold">
                                            Kết quả tìm kiếm
                                        </div>
                                        <div className="mt-3">
                                            <div className="white-space break-all text-sm text-gray-500">
                                                {datajoptiktok.jop_name?.[currentLang]
                                                    || datajoptiktok.jop_name?.vi
                                                    || datajoptiktok.jop_name?.en
                                                    || datajoptiktok.jop_name
                                                    || ""}
                                            </div>
                                            <div className="text-2xl text-blue-500 hover:underline">
                                                {datajoptiktok.jop_description?.[currentLang]
                                                    || datajoptiktok.jop_description?.vi
                                                    || datajoptiktok.jop_description?.en
                                                    || datajoptiktok.jop_description
                                                    || ""}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    ở kết quả trang 1 hoặc trang 2,3,4,5
                </div>
            ),
            3: (
                <div className="bg-gray-100">
                    {datajoptiktok.length !== 0 && (
                        <>
                            <div className="max-w-xl w-full p-2 space-y-2 bg-white rounded-md shadow-md text-center">
                                <div className="text-black text-lg">
                                    Khi trang tải{" "}
                                    <strong className="text-blue-500">Dành 30 giây</strong>{" "}
                                    xem trang web ấn vô các biểu tượng.
                                </div>
                                <div className="text-black text-sm">
                                    Bạn sẽ được duyệt sau khi làm đúng theo các bước
                                </div>
                            </div>
                            <div className="mt-3 p-1 bg-gradient-to-r from-pink-200 to-purple-200 rounded-md shadow-md">
                                <form>
                                    <div className="text-base font-bold text-blue-500 mb-2">
                                        Làm xong tắt chế độ quay màn hình và gửi videos
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                </div>
            ),
        };
    }

    // ====== 2️⃣ TIKTOK COMMENTS REF ======
    else if (datajoptiktok.category.includes("tik_cmts_ref")) {
        return {
            1: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold">
                            Bước 1: Tải ảnh và tìm TikTok
                        </div>
                        <p>
                            <a
                                href={`${datajoptiktok.image}?app=uiviewcontroller`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="px-4 py-2 text-base rounded-lg bg-green-600 text-white hover:bg-green-700 transition">
                                    📥 Tải ảnh (cập nhật liên tục)
                                </button>
                            </a>
                        </p>
                        <div className="text-black text-base mt-2">
                            Vào TikTok, tìm từ khóa{" "}
                            <span className="text-xl font-bold text-blue-500 cursor-pointer">
                                “{datajoptiktok.magiaodich}”
                            </span>{" "}
                            để bắt đầu nhiệm vụ.
                        </div>
                    </div>
                </div>
            ),
            2: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-left">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 2: Thả ảnh vào bình luận
                        </div>
                        <ul className="list-disc pl-5 space-y-1 text-black text-sm">
                            <li>Thả ảnh vào các bình luận đầu bảng.</li>
                            <li>
                                Tránh thả trực tiếp, chỉ tương tác ở các bình luận đầu bảng để
                                được duyệt.
                            </li>
                            <li>
                                Không yêu cầu số bình luận tối thiểu nhưng phải tương tác liên tục
                                trong 3 phút và đủ 4 clips khác nhau.
                            </li>
                        </ul>
                    </div>
                </div>
            ),
            3: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 3: Gửi video
                        </div>
                        <div className="text-black text-base">
                            Để tối ưu thời gian kiếm coins, hãy bắt đầu quay màn hình ngay khi mở
                            app TikTok để gửi lại cho Hust nhanh hơn.
                        </div>
                    </div>
                </div>
            ),
        };
    }

    // ====== 3️⃣ BOX SHARES ======
    else if (datajoptiktok.category.includes("box_shares")) {
        return {
            1: (
                <div className="bg-gray-100 flex justify-center">
                    <div className="w-full max-w-sm p-3 bg-white rounded-xl shadow-md text-center text-gray-800 text-base space-y-[2px] leading-snug">
                        <div className="font-medium">
                            Bật quay màn hình & share link đầu tiên
                        </div>
                        <div>Trên thiết bị để ghi lại quá trình share link.</div>
                        <div>
                            Mỗi ngày share ít nhất 2 nhóm Zalo, Messenger hoặc Telegram.
                        </div>
                    </div>
                </div>
            ),
            2: (
                <div className="bg-gray-100 flex justify-center">
                    <div className="w-full max-w-sm p-3 bg-white rounded-xl shadow-md text-center text-gray-800 text-base space-y-[2px] leading-snug">
                        <div className="font-medium">Tiếp tục share link vào nhiều nhóm</div>
                        <ul className="list-disc list-inside text-left space-y-[1px]">
                            <li>
                                {"Bào xiền đào lửa 1 ngày 8xx 🐟" +
                                    window.location.origin +
                                    datajoptiktok.url_jop}
                            </li>
                            <li>
                                {"Công cụ AI tăng tương tác miễn phí " +
                                    window.location.origin +
                                    datajoptiktok.url_jop}
                            </li>
                            <li>
                                {"Ví dụ :Nội dung tự nghĩ hỏi Ai cho phù hợp nhóm " +
                                    window.location.origin +
                                    datajoptiktok.url_jop}
                            </li>
                        </ul>
                    </div>
                </div>
            ),
            3: (
                <div className="bg-gray-100 flex justify-center">
                    <div className="w-full max-w-sm p-3 bg-white rounded-xl shadow-md text-center text-gray-800 text-base space-y-[2px] leading-snug">
                        <div className="font-medium">
                            Gửi video quay màn hình để nhận coins
                        </div>
                        <div>🎁 Nhận 3k đến 15k coins mỗi lượt gửi thành công.</div>
                        <ul className="list-disc list-inside text-left space-y-[1px]">
                            <li>Gửi nhóm chất lượng, có nội dung liên quan.</li>
                            <li>Hoặc nhóm đông người, nhiều người xem.</li>
                            <li>Share càng nhiều nhóm càng tốt.</li>
                        </ul>
                    </div>
                </div>
            ),
        };
    }

    // ====== 4️⃣ FB POSTS ======
    else if (datajoptiktok.category.includes("fb_posts")) {
        return {
            1: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold">
                            Bước 1: Tải ảnh và sao chép văn bản
                        </div>
                        <p>
                            <a
                                href={`${datajoptiktok.image}?app=uiviewcontroller`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="px-4 py-2 text-base rounded-lg bg-green-600 text-white hover:bg-green-700 transition">
                                    📥 Tải ảnh (cập nhật liên tục)
                                </button>
                            </a>
                            <div className="text-black text-base mt-2">
                                Văn bản dùng để đăng{" "}
                                <span className="text-base font-bold text-blue-500 cursor-pointer">
                                    “{datajoptiktok.url_copy}”
                                </span>{" "}
                            </div>
                        </p>
                    </div>
                </div>
            ),
            2: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-left">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 2: Vô fb tìm các nhóm Referral link hoặc Faucet hoặc Cloud Mining hoặc Airdrop hoặc BTC,LTC
                        </div>
                        <ul className="list-disc pl-5 space-y-1 text-black text-sm">
                            <li>Tìm các nhóm có chủ đề kiếm tiền quốc tế vợi từ khóa đã gợi ý</li>
                            <li>
                                Bạn cần vô các nhóm trước để có đủ số lượng nhóm đăng bài
                            </li>
                            <li>
                                Chỉ bắt đầu quay màn hình khi đã vô các nhóm xong
                            </li>
                        </ul>
                    </div>
                </div>
            ),
            3: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 3: Quay màn hình
                        </div>
                        <div className="text-black text-base">
                            Đăng bài gồm ảnh và văn bản cho trước
                        </div>
                        <div className="text-black text-base">
                            Cần tối thiểu đăng đủ 6 nhóm
                        </div>
                        <div className="text-black text-base">
                            Sau khi đăng xong gửi video lên Hust
                        </div>
                    </div>
                </div>
            ),
        };
    }

    // ====== 5️⃣ P2P VIDEOS ======
    else if (datajoptiktok.category.includes("p2p_videos")) {
        return {
            1: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold">
                            Bước 1: Tải ảnh và sao chép văn bản
                        </div>
                        <p>
                            <a
                                href={`${datajoptiktok.image}?app=uiviewcontroller`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <button className="px-4 py-2 text-base rounded-lg bg-green-600 text-white hover:bg-green-700 transition">
                                    📥 Tải ảnh (cập nhật liên tục)
                                </button>
                            </a>
                            <div className="text-black text-base mt-2">
                                Văn bản dùng để đăng{" "}
                                <span className="text-base font-bold text-blue-500 cursor-pointer">
                                    “{datajoptiktok.url_copy}”
                                </span>{" "}
                            </div>
                        </p>
                    </div>
                </div>
            ),
            2: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-left">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 2: Vô fb tìm các nhóm Referral link hoặc Faucet hoặc Cloud Mining hoặc Airdrop hoặc BTC,LTC
                        </div>
                        <ul className="list-disc pl-5 space-y-1 text-black text-sm">
                            <li>Tìm các nhóm có chủ đề kiếm tiền quốc tế vợi từ khóa đã gợi ý</li>
                            <li>
                                Bạn cần vô các nhóm trước để có đủ số lượng nhóm đăng bài
                            </li>
                            <li>
                                Chỉ bắt đầu quay màn hình khi đã vô các nhóm xong
                            </li>
                        </ul>
                    </div>
                </div>
            ),
            3: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 3: Gửi video
                        </div>
                        <div className="text-black text-base">
                            Để tối ưu thời gian kiếm coins, hãy bắt đầu quay màn hình ngay khi làm app để gửi lại cho Hust nhanh hơn.
                        </div>
                    </div>
                </div>
            ),
        };
    }
    else if (datajoptiktok.category.includes("p2p_mmo")) {
        return {
            1: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold">
                            Bước 1: Mô tả ngắn và hướng dẫn làm
                        </div>
                        <div className="text-black text-base">
                            {datajoptiktok.jop_name?.[currentLang]
                                || datajoptiktok.jop_name
                                || ""}
                        </div>
                        <div className="text-black text-sm">
                            {datajoptiktok.jop_description?.[currentLang]
                                || datajoptiktok.jop_description
                                || ""}
                        </div>
                        <div className="text-base text-blue-500 font-bold">
                            Chắc chắn tham gia thì mới ấn tiếp tục để làm
                        </div>
                    </div>
                </div>
            ),
            2: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-left">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 2: Đọc chi tiết các bước làm
                        </div>
                        <div className="text-black text-sm">
                            <div className="font-semibold">Link đến nhiệm vụ</div>
                            {datajoptiktok.url_jop && datajoptiktok.url_jop != "p2p_mmo" && (
                                <a
                                    href={datajoptiktok.url_jop}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-blue-600 hover:underline break-all"
                                >
                                    {datajoptiktok.url_jop}
                                </a>
                            )}
                            {!datajoptiktok.url_jop || datajoptiktok.url_jop == "p2p_mmo" && (
                                <> None </>
                            )}
                        </div>
                        <ul className="list-disc pl-5 space-y-1 text-black text-base">
                            {datajoptiktok.mission_comments?.[currentLang]
                                || datajoptiktok.mission_comments
                                || ""}
                        </ul>
                    </div>
                </div>
            ),
            3: (
                <div className="bg-gray-100">
                    <div className="max-w-xl w-full p-3 space-y-3 bg-white rounded-md shadow-md text-center">
                        <div className="text-base text-blue-500 font-bold mb-2">
                            Bước 3: Gửi video và gửi ghi chú cho người thuê nếu có
                        </div>
                        <div className="text-black text-base">
                            Để tối ưu thời gian kiếm coins, hãy bắt đầu quay màn hình ngay khi làm app để gửi lại cho Hust nhanh hơn.
                        </div>
                    </div>
                </div>
            ),
        };
    }
    return null;
}
